import { AttachmentContractTypeEnum } from '../enum';

export class Attachment {
  id: number;
  originalFilename: string;
  fileName: string;
  contentType: string;
  extension: string;
  downloadUrl: string;
  assetUrl: string;
  title: string;
  token: string;
  size: string;
  image: boolean;
  description: string;
  uploadedByDisplayname: string;
  created: string;
  rejected: boolean;
  attachmentRejectionReasonEnum: string;
  attachmentContractType: string;
  appComponentEnum: string;
  selected?: boolean = false;
}
